import React, { useState, useRef, useEffect } from 'react';
import Footer from '../components/Footer';
import safetyLogo from '../images/logo_safety100_mice.svg';
import {useNavigate} from 'react-router-dom';
import * as securityHelper from "../helper/SecurityHelper";
import axios from "axios";
import { fn_loginHandlerCallback } from '../api/FnCmmn'
import Snackbar from '../components/Snackbar';
export default function FindPw() {
    const navigate = useNavigate();
    const [snackbarTxt, setSnackbarTxt] = useState('');
    const idOrNameReference = useRef<any>(null);
    const regNumOrPhnNumReference = useRef<any>(null);
    const [cmpltPw, setCmpltPw] = useState(false);
    const [findUserIdOrNm, setFindUserIdOrNm] = useState('');
    const [foundPw, setFoundPw] = useState('');
    const [idOrPhnNum, setIdOrPhnNum] = useState('phnNum');

    useEffect(() => { snackbarTxt && setTimeout(() => setSnackbarTxt(''), 2000) }, [snackbarTxt]);

    const findPwHandler = async () => {
        let idOrName = idOrNameReference.current.value
        let regOrPhnNum = regNumOrPhnNumReference.current.value
        let srchType = idOrPhnNum === 'id' ? 'mobileId' : 'mobilePhnNum'
        let param = idOrPhnNum === 'id' ? {srchType: srchType, userId: idOrName, cmpnyRegNum: regOrPhnNum} : {srchType: srchType, name: idOrName, phone: regOrPhnNum}
        let rtrnData = await axios.post('admin/sign/checkUserForPw', param)
        if(idOrPhnNum === 'id' && !rtrnData.data.userId) {
            setSnackbarTxt(`일치하는 회원 정보가 없습니다.\n아이디와 사업자등록번호를 확인해주세요.`);
            return;
        } else if(idOrPhnNum === 'phnNum' && !rtrnData.data.name) {
            setSnackbarTxt(`일치하는 회원 정보가 없습니다.\n이름과 휴대폰번호를 확인해주세요.`);
            return;
        }
        setCmpltPw(true);
        if(idOrPhnNum === 'id') {
            setFindUserIdOrNm(rtrnData.data.userId);
            setFoundPw(rtrnData.data.inputPassword);
        } else {
            setFindUserIdOrNm(rtrnData.data.name);
            setFoundPw(rtrnData.data.inputPassword);
        }
    }

    return (
        <div className='w-screen h-[calc(100dvh)] flex flex-col items-center relative'>
            {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
            <div className='flex flex-col items-center justify-center'>
                <img className='mt-[20%] md:mt-[180px] w-[65%] md:w-[487px]' src={safetyLogo} alt='logo' />
                    <div className='w-full md:w-[450px]'>
                    {!cmpltPw ? <div className='w-full'>
                            <div className='mt-[2rem] md:mt-[80px] flex justify-center items-center'>
                                <div onClick={() => setIdOrPhnNum('phnNum')} className={`${idOrPhnNum === 'phnNum' ? 'bg-[#AAAA] text-white' : 'bg-[#D3D3D3] text-txtBlack'} w-full text-center py-[0.5rem] text-15`}>휴대폰번호로 찾기</div>
                                <div onClick={() => setIdOrPhnNum('id')} className={`${idOrPhnNum === 'id' ? 'bg-[#AAAA] text-white' : 'bg-[#D3D3D3] text-txtBlack'} w-full text-center py-[0.5rem] text-15`}>아이디로 찾기</div>
                            </div>
                            <p className='mt-[1.5rem] md:mt-[30px] text-18 md:text-40 mb-0'>{idOrPhnNum === 'id' ? '아이디' : '이름'}</p>
                            {idOrPhnNum === 'id' ?
                                <input
                                    className='w-full h-[2.6rem] md:h-[80px] bg-back pl-5 md:pl-[12px] outline-none border border-x-0 border-t-0 border-b-[0.5px] border-b-[#868686] md:text-42 text-white placeholder:text-[#868686] placeholder:text-15 placeholder:pl-7 placeholder:pb-10 md:placeholder:text-37 md:placeholder:pl-17 md:placeholder:pb-25'
                               ref={idOrNameReference} type='text' placeholder="아이디를 입력해주세요." />
                        : <input className='w-full h-[2.6rem] md:h-[80px] bg-back pl-5 md:pl-[12px] outline-none border border-x-0 border-t-0 border-b-[0.5px] border-b-[#868686] md:text-42 text-white placeholder:text-[#868686] placeholder:text-15 placeholder:pl-7 placeholder:pb-10 md:placeholder:text-37 md:placeholder:pl-17 md:placeholder:pb-25'
                               ref={idOrNameReference} type='text' placeholder="이름을 입력해주세요." /> }
                        <p className='text-18 mt-15 md:mt-50 md:text-40'>{idOrPhnNum === 'id' ? '사업자등록번호' : '휴대폰번호'}</p>
                        <input className='mb-15 w-full h-[2.6rem] md:h-[80px] bg-back pl-5 md:pl-[12px] outline-none border border-x-0 border-t-0 border-b-[0.5px] border-b-[#868686] md:text-42 text-white placeholder:text-[#868686] placeholder:text-15 placeholder:pl-7 placeholder:pb-10 md:placeholder:text-37 md:placeholder:pl-17 md:placeholder:pb-25'
                               ref={regNumOrPhnNumReference} type='text' placeholder="‘-’ 없이 숫자만 입력해주세요." />
                        <Btn clickHandler={findPwHandler} login>비밀번호 찾기</Btn> </div>
                    : <div className='w-full flex flex-col items-center mt-[6rem] mb-[2rem] md:mt-30 md:mb-30'><p className='text-18 md:text-40 mb-0'>[ {findUserIdOrNm} ]님의 임시 비밀번호는</p>
                        <p className='text-18 mt-15 md:mt-50 md:text-40 mb-0'>[ {foundPw} ] 입니다.</p>
                        <p className='text-18 mt-15 md:mt-50 md:text-40 mb-0'>로그인 후 마이페이지에서</p>
                        <p className='text-18 mt-15 md:mt-50 md:text-40 mb-0'>비밀번호를 변경하세요.</p></div>}
                        <Btn clickHandler={() => navigate('/signUp')} signUp>로그인 화면</Btn> </div>
            </div>
            <Footer />
        </div>
    );
}

const Btn = ({ login, signUp, clickHandler, children }: any) => {
    return (
        <button
            className={`md:mt-[75px] text-20 md:text-37 leading-18 md:leading-36 w-full py-[0.7rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px]
            ${login ? 'mt-[1.4rem] bg-gradient-to-r from-gdFrom to-gdTo' : signUp ? 'mt-[0.8rem] bg-gradient-to-r from-gdNfcFrom to-gdNfcTo' : 'mt-[0.8rem] bg-[#585959]'}`}
            onClick={clickHandler}>{children}</button>
    );
};